import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useCustomerInfo = () => {
  const query = useQuery({
    queryKey: [QueryKeys.CUSTOMER_INFO],
    queryFn: () => accountRepo.getCustomerWithPhysicalAddress(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseCustomerInfo = ReturnType<typeof useCustomerInfo>;
